import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import MapFactory from './MapFactory'
import { array, number, func, string, bool, object } from 'prop-types'
import { delay } from 'lodash'
import { getDefaultPolygon, getBounds } from './MapUtils'
import { mapbox, maxBounds, mapInstance, mapboxSatellite } from '../../config'
import { toggleSidebar } from '../../store/Actions/UiActions'
import {
  updateZoom,
  getViewPortRadius,
  updateCenter,
  updateStreetViewCenter,
  updateInfobox,
  handleUpdatePolygon,
} from '../../store/Actions/MapActions'
import './styles/Map.css'

class MapBox extends Component {
  getViewPortPolygon = async e => {
    const bounds = e.getBounds()
    const polygon = getDefaultPolygon(bounds)
    await this.props.handleUpdatePolygon(polygon)
    let center = [e.transform._center.lng, e.transform._center.lat]
    this.handleUpdateCenter(center)
  }

  handleUpdateCenter = async center => {
    await this.props.updateCenter(center)
  }

  updateCenterAndRadius = async (center, radius) => {
    await this.props.updateCenter(center)
    await this.props.updateRadius(radius)
    if (!this.props.streetViewShow && !this.props.cycloramaShow) {
      this.props.updateStreetViewCenter({ lat: center[1], lng: center[0] })
    }
  }

  handleDrag = async e => {
    let center = [e.transform._center.lng, e.transform._center.lat]
    this.updateCenterAndRadius(center, e.getBounds())
  }

  handleZoom = async e => {
    let center = [e.transform._center.lng, e.transform._center.lat]
    await this.props.updateZoom(e.transform.zoom)
    this.updateCenterAndRadius(center, e.getBounds())
  }

  center = () =>
    this.props.streetViewShow || this.props.cycloramaShow
      ? [this.props.streetViewCenter.lng, this.props.streetViewCenter.lat]
      : this.props.center

  handleMapClick = () => {
    this.props.toggleSidebar(false)
    this.nullifyInfobox()
  }

  nullifyInfobox = () => {
    this.props.updateInfobox({
      coordinates: null,
      signs: null,
      sign: null,
      type: null,
    })
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    if (nextProps.streetViewShow || nextProps.cycloramaShow) {
      return this.props.streetViewCenter !== nextProps.streetViewCenter
    }
    return (
      this.props.signs !== nextProps.signs ||
      (this.props.compassRotate && this.props.angle !== nextProps.angle) ||
      this.props.satellite !== nextProps.satellite
    )
  }

  saveMapInstance = map => {
    if (mapInstance) {
      window.mapInstance = map
    }
  }

  render() {
    const geoJson = this.props.signs.length > 0 ? this.props.signs : ''
    const fitBoundsOptions = {
      padding: { top: 10, bottom: 10, left: 10, right: 10 },
    }
    return (
      <MapFactory
        style={this.props.satellite ? mapboxSatellite : mapbox}
        containerStyle={{ height: this.props.height, width: this.props.width }}
        center={this.center()}
        zoom={[this.props.zoom]}
        movingMethod="jumpTo"
        maxBounds={maxBounds}
        onClick={() => this.handleMapClick()}
        onZoom={e => this.handleZoom(e)}
        onMove={e => this.handleDrag(e)}
        onMoveEnd={e => this.getViewPortPolygon(e)}
        bearing={[this.props.compassRotate ? this.props.angle : 0]}
        ref={map => this.saveMapInstance(map)}
        fitBounds={geoJson !== '' ? getBounds(geoJson) : ''}
        fitBoundsOptions={fitBoundsOptions}
        // onDragEnd={() => this.nullifyInfobox()}
      >
        {this.props.children}
      </MapFactory>
    )
  }
}

MapBox.defaultProps = {
  angle: 0,
  satellite: false,
}

MapBox.propTypes = {
  center: array,
  zoom: number.isRequired,
  updateZoom: func.isRequired,
  angle: number.isRequired,
  height: string.isRequired,
  width: string.isRequired,
  updateRadius: func.isRequired,
  toggleSidebar: func.isRequired,
  updateStreetViewCenter: func.isRequired,
  streetViewShow: bool.isRequired,
  cycloramaShow: bool.isRequired,
  streetViewCenter: object.isRequired,
  listShow: bool.isRequired,
  satellite: bool.isRequired,
}

const mapStateToProps = ({ map, signsState, spi, ui }) => ({
  center: map.center,
  streetViewShow: ui.streetViewShow,
  zoom: map.zoom,
  angle: map.angle,
  compassRotate: spi.compassRotate,
  signs: signsState.cache.signs,
  cycloramaShow: ui.cycloramaShow,
  streetViewCenter: map.streetViewCenter,
  listShow: ui.listShow,
  satellite: map.satellite,
})

const mapDispatchToProps = dispatch => ({
  updateZoom: value => dispatch(updateZoom(value)),
  updateRadius: value => dispatch(getViewPortRadius(value)),
  updateCenter: value => dispatch(updateCenter(value)),
  toggleSidebar: value => dispatch(toggleSidebar(value)),
  updateStreetViewCenter: value => dispatch(updateStreetViewCenter(value)),
  updateInfobox: value => dispatch(updateInfobox(value)),
  handleUpdatePolygon: value => dispatch(handleUpdatePolygon(value)),
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MapBox)
)



// WEBPACK FOOTER //
// ./src/components/Map/MapBox.jsx